import styles from "./OrderSettingsPage.module.css"
import Navbar from "../../components/Navbar/NavbarOnboarding/Navbar";
import OrderSettingsForm from "./components/OrderSettingsForm/OrderSettingsForm";
import { useTranslation } from "react-i18next";
/**
* Order settings page
* Contains order settings form
* @returns TSX.Element
*/
const OrderSettingsPage = () => {
    const { t } = useTranslation(); // Translation
    return(
        <>
            <Navbar/>
            <div className={styles.Page}>
                <div className={styles.OrderSettingsBlock}>
                    <div className={styles.OrderSettingsTitle}>
                        {t("order_settings.title")}
                    </div>
                    <div className={styles.OrderSettingsFormBlock}>
                        <OrderSettingsForm/>
                        <div className={styles.Info}>
                            <p>{t("order_settings.disclaimer")}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default OrderSettingsPage;
